export default __webpack_public_path__ + "static/media/cast-iron.1afa45fe.png";